module.exports = __webpack_public_path__ + "static/media/menu-menus.b18f3f5f.svg";